import { UnitSource } from "./NumberWithUnit";

export class Unit {
    private _abbreviation: string;
    private _displayString: string;

    constructor(abbreviation: string, displayString: string) {
        this._abbreviation = abbreviation;
        this._displayString = displayString;
    }

    public get abbreviation(): string {
        return this._abbreviation;
    }

    public get displayString(): string {
        return this._displayString;
    }

    public equals(otherUnit: Unit) {
        return otherUnit != null && this.abbreviation === otherUnit.abbreviation;
    }

    public static resolveAbbreviation(unit: UnitSource): string {
        return (unit instanceof Unit) ? unit.abbreviation : unit;
    }
}
